<template>
  <!-- 奖池弹窗（奖池图片） -->
  <div v-if="currentAward">
    <div class="Dialog jc-prize">
      <div class="inner-box">
        <div class="inner">
			<i class="close" @click="closeDialog"></i>
			<div class="jc-prize-box">
                <div class="ribbons"></div>
                <!-- 抽中奖品 -->
                <div class="point-coupon">
					<div class="coupon-con">
						<div class="coupon-con-t">
						   <img :src="currentAward.url" alt="">
						   <p>{{ currentAward.name }}</p>
						</div>
						<div class="coupon-con-b">
							<div class="describe">
								<span></span>
								<div class="txt">
									{{ hasReceived ? "已领取" : "恭喜获得"}}
                                    <p>{{lotteryInfo.num}}<i>{{currencyName}}</i></p>档位奖励
								</div>
								<span></span>
							</div>
							<p class="tip">奖品请在游戏邮箱中领取，如遇延迟请等待</p>
						</div>
						
					</div>
					<div class="stage-list">
						<img class="stage" src="~2021team-pk-ui/assets/stage.png" alt="">
						<div class="arr-l"></div>
						<div class="arr-r"></div>
						<div class="stage-btns">
							<div class="stage-btn stage-btn-r" @click="closeDialog">
								确定<span></span>
							</div>
						</div>
						<div class="army"></div>
					
					</div>
				</div>
				<div class="caption">
					<img class="caption-l" src="~2021team-pk-ui/assets/index-title-icon-l.png" alt="">
					{{lotteryInfo.name}} 奖品一览
					<img class="caption-r" src="~2021team-pk-ui/assets/index-title-icon-r.png" alt="">
				</div>
                <p class="prize-tip2" v-if="lotteryInfo.resultName">组队成功后，个人消费超过{{lotteryInfo.num}}{{currencyName}}即可领取以下奖励</p>
                <p class="prize-tip2" v-else>团队共消耗{{lotteryInfo.num}}{{currencyName}}且个人消耗>1{{currencyName}}即可随机获得以下奖励</p>			
				<div class="prize-props" v-if="lotteryInfo.imgList && lotteryInfo.imgList.length">
					<img v-for="(img,i) in lotteryInfo.imgList" key="'lotteryInfoImg' + i" v-if="img" class="prize-props-img" :src="img" alt="" />
				</div>
			</div>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import myMinin from "./mixin"
import * as config from "../config"

export default {
  name: "ReceivedAwardDialog",
  props: ["lotteryInfo", "gameInfo", "currentAward"],
  mixins: [myMinin],
  computed: {
    currencyName() {
      return this.gameInfo?.shop?.currency || "点券"
    },
    hasReceived() {
      return this.lotteryInfo?.status == config.PRIZESTATUS.RECEIVED
    }
  },
  methods: {
    ...mapActions(["reportUserAction"]),
    closeDialog() {
      document.documentElement.style.overflow = "scroll"
      this.$emit("update:currentAward", null)
    }
  },
  mounted() {
    if (this.currentAward) {
      this.reportUserAction({
        iformat: config.REPORT.PAGEVIEW.LOTTERY_DRAW_SUCCESS_ITEM,
        resultInfo: this.currentAward
      })
    }
  }
}
</script>

<style scoped>
</style>
